<template>
  <v-container grid-list-xs pb-0 pt-0>
    <v-layout row wrap align-center ml-1>
      <v-flex xs6>
        <v-card class="main-card mb-2 mt-2">
          <v-card-title class="justify-center pa-1">
            <img src="/static/blueyonder_logo.svg" width="115px" class="hidden-xs-only">
          </v-card-title>

          <v-divider class="primary ml-2 mr-2"></v-divider>

          <v-card-text>
            <v-container grid-list-lg pb-0 pt-0>
              <v-layout row wrap align-center>
                <v-window v-model="paymentStatus">
                  <v-window-item :value="0">
                    <v-container ma-0 pa-0>
                      <v-layout row wrap align-center>
                        <v-flex xs12 pa-0 ma-0>
                        </v-flex>
                        <template v-if="!payFull">
                          <v-flex xs2 class="text-xs-center">
                            <v-icon color="primary" medium>fa-dollar</v-icon>
                          </v-flex>
                          <v-flex xs10>
                            <v-text-field
                              class="payment-input pa-0 ma-0"
                              flat
                              hide-details
                              single-line
                              solo
                              type="tel"
                              v-model="amount"
                            ></v-text-field>
                            <v-layout row class="ma-0 mt-1" style="border: 1px solid #44a9e2;cursor: pointer;" @click="showPriceAdjustmentFee=true" v-if="!transaction.is_fee_waived && terminal.is_cashdiscount && transaction.request_type !== 'ach' && !showPriceAdjustmentFee">
                              <v-flex class="pa-1 pt-2 pl-2 caption white primary--text text-truncate">
                                Show Price Adj Fee
                              </v-flex>
                              <v-flex shrink class="pa-0 white">
                                <v-divider vertical class="primary"></v-divider>
                              </v-flex>
                              <v-flex shrink class="pa-1 pl-2 pr-2 caption white primary--text">
                                &or;
                              </v-flex>
                            </v-layout>
                            <v-layout row class="ma-0 mt-1" style="border: 1px solid #44a9e2;cursor: pointer;" @click="showPriceAdjustmentFee=false" v-if="!transaction.is_fee_waived && terminal.is_cashdiscount && transaction.request_type !== 'ach' && showPriceAdjustmentFee">
                              <v-flex class="pa-1 pl-2 caption primary white--text">
                                {{ priceAdjustmentFee }}
                              </v-flex>
                              <v-flex shrink class="pa-0 primary">
                                <v-divider vertical class="white"></v-divider>
                              </v-flex>
                              <v-flex shrink class="pa-1 pl-2 pr-2 caption primary white--text">
                                &and;
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </template>
                        <v-flex xs2 class="text-xs-center">
                          <v-icon color="primary" medium>fa-user</v-icon>
                        </v-flex>
                        <v-flex xs10 subheading>
                          {{ transaction.card_name }}
                        </v-flex>
                        <v-flex xs2 class="text-xs-center">
                          <img slot="append" :src="'/static/cards/' + this.transaction.payment_type + '.svg'" height="24px" v-if="this.transaction.payment_type && this.transaction.payment_type !== 'unknown'">
                        </v-flex>
                        <v-flex xs10 subheading>
                          {{ cardMaskPrefix }}{{ transaction.last_four }}
                        </v-flex>
                        <v-flex xs2 class="text-xs-center">
                          <v-icon color="primary" medium>fa-calendar-check-o</v-icon>
                        </v-flex>
                        <v-flex xs10 subheading>
                          {{ expiration(transaction.card_expiration) }}
                        </v-flex>
                        <v-flex xs2 class="text-xs-center">
                          <v-icon color="primary" medium>fa-lock</v-icon>
                        </v-flex>
                        <v-flex xs10>
                          <v-text-field
                            v-model="cvvMask"
                            class="payment-input pa-0 ma-0"
                            disabled
                            flat
                            hide-details
                            single-line
                            solo
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs2 class="text-xs-center">
                          <v-icon color="primary" medium>fa-calendar-plus-o</v-icon>
                        </v-flex>
                        <v-flex xs10>
                          <v-menu
                            v-model="closeDateModal"
                            ref="closeDateModal"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="close_date"
                            full-width
                            lazy
                            min-width="290px"
                            offset-y
                            transition="scale-transition"
                          >
                            <v-text-field
                              v-model="formattedCloseDate"
                              label="Post Date"
                              slot="activator"
                              class="payment-input pa-0 ma-0"
                              flat
                              hide-details
                              readonly
                              single-line
                              solo
                            />
                            <v-date-picker
                              v-model="close_date"
                              :min="minimumCloseDate"
                              @input="$refs.closeDateModal.save(close_date)"
                            />
                          </v-menu>
                        </v-flex>

                        <v-flex xs12 class="text-xs-center">
                          <v-btn
                            class="pay-button title"
                            color="primary"
                            block
                            depressed
                            large
                            @click="processPayment"
                            >
                            Pay <span v-if="payFull">&nbsp;{{ money(amountRemaining) }}&nbsp;</span> NOW
                          </v-btn>
                          <!--
                          <v-layout row class="ma-0 mt-1" style="border: 1px solid #44a9e2;cursor: pointer;" @click="showPriceAdjustmentFee=true" v-if="terminal.is_cashdiscount && !showPriceAdjustmentFee">
                            <v-flex class="pa-1 pt-2 pl-2 caption white primary--text text-truncate">
                              Show Price Adj Fee
                            </v-flex>
                            <v-flex shrink class="pa-0 white">
                              <v-divider vertical class="primary"></v-divider>
                            </v-flex>
                            <v-flex shrink class="pa-1 pl-2 pr-2 caption white primary--text">
                              &or;
                            </v-flex>
                          </v-layout>
                          <v-layout row class="ma-0 mt-1" style="border: 1px solid #44a9e2;cursor: pointer;" @click="showPriceAdjustmentFee=false" v-if="terminal.is_cashdiscount && showPriceAdjustmentFee">
                            <v-flex class="pa-1 pl-2 caption primary white--text">
                              {{ priceAdjustmentFee }}
                            </v-flex>
                            <v-flex shrink class="pa-0 primary">
                              <v-divider vertical class="white"></v-divider>
                            </v-flex>
                            <v-flex shrink class="pa-1 pl-2 pr-2 caption primary white--text">
                              &and;
                            </v-flex>
                          </v-layout>
                          -->
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-window-item>

                  <v-window-item :value="1">
                    <v-flex class="text-xs-center">
                      <v-icon color="primary" class="xxl-icon">fa-check-circle</v-icon>
                    </v-flex>
                    <v-flex class="text-xs-center title">
                      Payment <span class="primary--text">Complete</span>
                    </v-flex>
                    <v-flex class="font-weight-thin text-xs-center title pt-2">
                      <a @click="paymentStatus = 2">Show details?</a>
                    </v-flex>
                  </v-window-item>

                  <v-window-item :value="2">
                    <v-container ma-1 pa-0>
                      <v-layout row wrap align-center>
                        <v-flex xs3 class="primary--text">Billing:</v-flex>
                        <v-flex xs9>{{ transactionDetails.card_name }}</v-flex>

                        <v-flex xs3 class="primary--text">Address:</v-flex>
                        <v-flex xs9>{{ transactionDetails.billing_address }}</v-flex>
                        <v-flex xs3 class="primary--text">Balance:</v-flex>
                        <v-flex xs9>{{ money(transactionDetails.total_amount / 100) }} <span class="primary--text">PAID</span></v-flex>
                        <v-flex xs3 class="primary--text">VISA:</v-flex>
                        <v-flex xs9>{{ cardMaskPrefix }}{{ transactionDetails.last_four }}</v-flex>
                        <v-flex xs3 class="primary--text">Type:</v-flex>
                        <v-flex xs9>SALE / <span class="primary--text">APPROVED</span></v-flex>
                        <v-flex xs3 class="primary--text">Auth No:</v-flex>
                        <v-flex xs9>{{ transactionDetails.approval_code }}</v-flex>
                        <v-flex xs3 class="primary--text">Trans ID:</v-flex>
                        <v-flex xs9>{{ transactionDetails.tracking_id }}</v-flex>
                        <v-flex xs3 class="primary--text">Trans Date:</v-flex>
                        <v-flex xs9>{{ date(transactionDetails.authorized) }}</v-flex>
                      </v-layout>
                    </v-container>
                  </v-window-item>
                </v-window>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs6>
        <v-card elevation="0">
          <v-card-text>
            <v-container grid-list-xs pa-0 ma-0>
              <v-layout row wrap align-center justify-center>
                <v-window v-model="payStep">
                  <v-window-item :value="1">
                    <v-flex>
                      <span class="primary--text subheading">Payment Details:</span> {{ transaction.card_name }}
                      <v-divider class="mt-2 mb-2"></v-divider>
                    </v-flex>
                    <v-flex class="payment-secondary-input-container">
                      <v-text-field
                        label="Customer PO"
                        v-model="customer_po"
                        class="payment-secondary-input"
                        full-width
                        outline
                      ></v-text-field>
                    </v-flex>
                    <v-flex class="payment-secondary-input-container">
                      <v-text-field
                        label="Custom Field 1"
                        v-model="custom_field_1"
                        class="payment-secondary-input"
                        outline
                      ></v-text-field>
                    </v-flex>
                    <v-flex class="payment-secondary-input-container">
                      <v-text-field
                        label="Custom Field 2"
                        v-model="custom_field_2"
                        outline
                        class="payment-secondary-input"
                      ></v-text-field>
                    </v-flex>
                    <v-flex class="payment-secondary-input-container">
                      <v-text-field
                        label="Custom Field 3"
                        v-model="custom_field_3"
                        outline
                        class="ma-0 pa-0
                        payment-secondary-input"
                      ></v-text-field>
                    </v-flex>
                    <v-flex class="payment-secondary-input-container">
                      <v-textarea
                        label="Notes"
                        v-model="notes"
                        outline rows="2"
                        class="ma-0 pa-0 payment-secondary-input"
                      ></v-textarea>
                    </v-flex>
                  </v-window-item>

                  <v-window-item :value="2">
                    <v-flex class="text-xs-center">
                      <img src="/static/Spinner-1s-200px.svg">
                    </v-flex>
                    <v-flex class="primary--text text-xs-center title">
                      Processing...
                    </v-flex>
                    <v-flex class="font-weight-thin text-xs-center title pt-2">
                      Please be patient!
                    </v-flex>
                  </v-window-item>

                  <v-window-item :value="3">
                    <v-container grid-list-lg>
                      <v-layout row wrap align-center>
                        <v-flex xs2></v-flex>
                        <v-flex xs10 font-weight-medium subheading>
                          Do you want to:
                        </v-flex>

                        <v-flex xs2>
                          <v-icon color="primary" medium>fa-edit</v-icon>
                        </v-flex>
                        <v-flex xs10 font-weight-thin subheading>
                          <template v-if="transaction.payment_type==='ach'">
                            <a to="/ach?i=1">Create a new schedule..?</a>
                          </template>
                          <template v-else>
                            <a to="/credit?i=1">Create a new schedule..?</a>
                          </template>
                        </v-flex>

                        <v-flex xs2>
                          <v-icon color="primary" medium>fa-wrench</v-icon>
                        </v-flex>
                        <v-flex xs10 font-weight-thin subheading>
                          <a @click="switchToModify">Modify installment schedule..?</a>
                        </v-flex>

                        <v-flex xs2>
                          <v-icon color="primary" medium>fa-print</v-icon>
                        </v-flex>
                        <v-flex xs10 font-weight-thin subheading>
                          <a @click="printReceipt">Print this payment</a>
                        </v-flex>

                        <v-flex xs2 v-if="transaction.billing_email">
                          <v-icon color="primary" medium>fa-envelope</v-icon>
                        </v-flex>
                        <v-flex xs10 font-weight-thin subheading v-if="transaction.billing_email">
                          <a @click="emailReceipt">Email this payment</a>
                        </v-flex>

                        <v-flex xs2>
                          <v-icon color="primary" large>fa-angle-left</v-icon>
                        </v-flex>
                        <v-flex xs10 subheading>
                          <a @click="closeModal">Go back to Installment Options</a>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-window-item>

                  <v-window-item :value="-1">
                    <v-container grid-list-lg>
                      <v-layout row wrap align-center>

                        <v-flex xs12 class="text-xs-center">
                          <v-icon color="primary" class="xxl-icon">fa-exclamation-triangle</v-icon>
                        </v-flex>
                        <v-flex xs12 class="text-xs-center title">
                          <span class="primary--text">Uh-oh</span>...payment has <span class="primary--text">FAILED</span>
                        </v-flex>
                        <v-flex xs12 class="subtitle text-xs-center">
                          {{ responseMessage }}
                        </v-flex>
                        <v-flex xs12 class="body-2 text-xs-center">
                          {{ responseMessageDetails }}
                        </v-flex>

                        <v-divider class="primary mt-2 mb-2"></v-divider>

                        <v-flex xs2>
                          <v-icon color="primary" medium>fa-refresh</v-icon>
                        </v-flex>
                        <v-flex xs10 font-weight-thin subheading @click="processPayment">
                          <a>Try again with this card...?</a>
                        </v-flex>

                        <v-flex xs2>
                          <v-icon color="primary" medium>fa-credit-card</v-icon>
                        </v-flex>
                        <v-flex xs10 font-weight-thin subheading>
                          Use a different card..?
                        </v-flex>

                        <v-flex xs2>
                          <v-icon color="primary" large>fa-angle-left</v-icon>
                        </v-flex>
                        <v-flex xs10 subheading @click="closeModal">
                          <a>Go back to Installment Options</a>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-window-item>
                </v-window>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <ReceiptPrint ref="receipt" :transaction="transactionDetails"></ReceiptPrint>
  </v-container>
</template>

<script>
import Moment from 'moment'
import Bus from '@/bus'

import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import CashDiscountMixin from '@/mixins/cashDiscount'
import DisplayMixin from '@/mixins/display'
import PlansMixin from '@/mixins/plans'
import StoreMixin from '@/store/mixin'
import UtilityMixin from '@/mixins/utility'

import ReceiptPrint from '@/components/transactions/ReceiptPrint.vue'

export default {
  mixins: [ApiMixin, AuthMixin, CashDiscountMixin, DisplayMixin, PlansMixin, StoreMixin, UtilityMixin],
  components: {ReceiptPrint},
  data: function () {
    return {
      enabled: false,
      payStep: 1,
      paymentStatus: 0,
      amount: null,
      showPriceAdjustmentFee: false,
      customer_po: '',
      custom_field_1: '',
      custom_field_2: '',
      custom_field_3: '',
      notes: '',
      close_date: null,

      isResponseError: false,
      responseMessage: '',
      responseMessageDetails: '',
      transactionDetails: {},
      closeDateModal: false,
      submitNonce: this.generateId(36)
    }
  },

  props: {
    payFull: Boolean,
    terminal: Object,
    transactions: Array,
    transaction: Object,
    finalTransaction: Object,
    amountRemaining: Number
    // scheduledTransactions: Array
    // downpaymentTransaction: Object,
  },

  beforeDestroy () {
    this.closeModal()
  },

  mounted () {
    this.load()
    this.payStep = 1

    if (this.transaction) {
      this.customer_po = this.transaction.customer_po
      this.custom_field_1 = this.transaction.custom_field_1
      this.custom_field_2 = this.transaction.custom_field_2
      this.custom_field_3 = this.transaction.custom_field_3
    }
  },

  updated () {
    if (this.transaction) {
      this.customer_po = this.transaction.customer_po
      this.custom_field_1 = this.transaction.custom_field_1
      this.custom_field_2 = this.transaction.custom_field_2
      this.custom_field_3 = this.transaction.custom_field_3
    }
  },

  computed: {
    cardMaskPrefix () {
      if (this.transaction.payment_type === 'amex') {
        return '**** ****** *'
      } else if (this.transaction.payment_type === 'diners') {
        return '**** ****** *'
      } else if (this.transaction.payment_type === 'discover') {
        return '**** **** **** '
      } else if (this.transaction.payment_type === 'jcb') {
        return '**** **** **** '
      } else if (this.transaction.payment_type === 'jcb15') {
        return '**** ****** *'
      } else if (this.transaction.payment_type === 'maestro') {
        return '**** **** **** '
      } else if (this.transaction.payment_type === 'mastercard') {
        return '**** **** **** '
      } else if (this.transaction.payment_type === 'unionpay') {
        return '**** **** **** '
      } else if (this.transaction.payment_type === 'visa') {
        return '**** **** **** '
      }
      return '**** **** **** '
    },

    cvvMask () {
      if (this.transaction.payment_type === 'amex' || this.transaction.payment_type === 'diners' || this.transaction.payment_type === 'jcb15') {
        return '****'
      }
      return '***'
    },

    priceAdjustmentFee: function () {
      if (this.payFull) {
        return this.calculateFee(this.terminal, this.amountRemaining)
      } else {
        return this.calculateFee(this.terminal, this.amount)
      }
    },

    formattedCloseDate () {
      return this.close_date ? Moment(this.close_date).format('MMM-DD-YYYY') : ''
    },

    minimumCloseDate: function () {
      // return Moment().add(1, 'days').format('YYYY-MM-DD')
      return Moment().format('YYYY-MM-DD')
    }
  },

  methods: {
    async load () {},

    closeModal () {
      Bus.$emit('closePayModal')

      this.payStep = 1
      this.paymentStatus = 0
      this.amount = null
      this.showPriceAdjustmentFee = false
      this.customer_po = ''
      this.custom_field_1 = ''
      this.custom_field_2 = ''
      this.custom_field_3 = ''
      this.close_date = null
      this.isResponseError = false
      this.responseMessage = ''
      this.responseMessageDetails = ''
      this.transactionDetails = {}
    },

    switchToModify () {
      this.closeModal()

      Bus.$emit('showModifyModal')
    },

    async processPayment () {
      try {
        this.payStep = 2
        this.paymentStatus = 0
        this.isResponseError = false
        this.responseMessage = ''
        this.responseMessageDetails = ''
        this.transactionDetails = {}

        // @TODO if not full, validate amount

        let options = {
          token: this.transaction.token,
          terminal_id: this.terminal.id,
          card_name: this.transaction.billing_name ? this.transaction.billing_name : this.transaction.card_name,
          order_number: this.transaction.order_number,
          customer_po: this.customer_po,
          custom_field_1: this.custom_field_1,
          custom_field_2: this.custom_field_2,
          custom_field_3: this.custom_field_3,
          custom: JSON.stringify(this.transaction.custom),
          // custom: this.transaction.custom,
          notes: this.notes,
          billing_address: this.transaction.billing_address,
          billing_city: this.transaction.billing_city,
          billing_state: this.transaction.billing_state,
          billing_postalcode: this.transaction.billing_postal_code,
          billing_country: this.transaction.billing_country,
          billing_phone: this.transaction.billing_phone,
          billing_email: this.transaction.billing_email
        }

        if (this.transaction.request_type === 'sale') {
          options.request_type = 'sale'
        } else if (this.transaction.request_type === 'ach') {
          options.request_type = 'ach'
          options.ach_authorization = 'onfile'
        } else {
          // Bus.$emit('openModal', {
          //   status: 'error',
          //   message: 'Cannot determine payment type'
          // })
          this.isResponseError = true
          this.responseMessage = 'Cannot determine payment type'
          this.payStep = -1
          return false
        }

        if (this.payFull) {
          options.amount = this.amountRemaining
        } else {
          options.amount = this.amount
        }

        if (this.transaction.is_cashdiscount && this.transaction.request_type !== 'ach' && !this.transaction.is_fee_waived) {
          options.fee = this.priceAdjustmentFee
        } else if (this.transaction.is_cashdiscount && this.transaction.request_type !== 'ach' && this.transaction.is_fee_waived) {
          options.waive_fee = this.transaction.is_fee_waived
          options.fee_waived = this.priceAdjustmentFee
        }

        if (this.transaction.transaction_group_id) {
          options.transaction_group_id = this.transaction.transaction_group_custom_tracking_id
          options.is_installment = this.transaction.is_installment
        }

        if (this.close_date && Moment().isBefore(this.close_date)) {
          options.close_date = this.close_date
        }

        options.nonce = this.generateId(36)

        let result = await this.api({
          method: 'post',
          url: `/terminal/payment`,
          data: options
        })

        this.transactionDetails = Object.assign({}, result.data.response.Transaction)

        if (result.data.response.ResponseText === 'APPROVED') {
          // this.transactionDetails = result.data.response.Transaction
          this.responseMessage = 'Payment Approved'
        } else if (result.data.response.ResponseText === 'PENDING') {
          // this.transactionDetails = result.data.response.Transaction
          this.responseMessage = 'Scheduled Payment Approved'
        } else if (result.data.response.ResponseText === 'CHECK ACCEPTED') {
          // this.transactionDetails = result.data.response.Transaction
          this.responseMessage = 'Payment Accepted'
        } else {
          let error = result.data.response.ResponseText
          if (result.data.response.ErrMsg) {
            error += ': ' + result.data.response.ErrMsg
          }
          this.isResponseError = true
          this.responseMessage = error
          this.responseMessageDetails = ''

          if (error === 'DECLINED' && this.transaction.request_type === 'sale') {
            this.responseMessageDetails = 'Please verify card data including the expiration and CVV'
          }

          if (result.data.response.Transaction && result.data.response.Transaction.hasOwnProperty('error_messages') && result.data.response.Transaction.error_messages) {
            let messages = JSON.parse(result.data.response.Transaction.error_messages)

            // show detailed error as long as it isn't the generic 'do not honor'
            if (messages.length > 0 && messages[0] !== 'TRANS DENIED DO NOT HONOR' && messages[0] !== error) {
              this.responseMessageDetails = messages.join()
            }
          }

          this.submitNonce = this.generateId(36)
        }

        // if not payFull calculate if last payment
        // if payFull && not started
        //    void recurring
        //    void last
        // if payFull && started
        //    cancel recurring
        //    void last

        // @TODO payFull might not be set, but they might have typed in the full amount...
        // if all is successful, cancel all the previous
        if (this.payFull && (
          result.data.response.ResponseText === 'APPROVED' ||
          result.data.response.ResponseText === 'PENDING' ||
          result.data.response.ResponseText === 'CHECK ACCEPTED'
        )) {
          await this.cancelAllPendingTransactions(this.transactions)
        }

        if (this.isResponseError) {
          this.payStep = -1
        } else {
          this.payStep = 3
          this.paymentStatus = 1
          Bus.$emit('reloadPlan')
        }
      } catch (err) {
        this.submitNonce = this.generateId(36)
        // Bus.$emit('openModal', {
        //   status: 'error',
        //   message: err
        // })
        this.payStep = -1
      } finally {}
    },

    printReceipt () {
      this.$refs.receipt.print()
    },

    async emailReceipt () {
      try {
        if (!this.transactionDetails || !this.transactionDetails.id) {
          throw new Error('Unable to identify transaction')
        }

        let result = await this.api({
          method: 'get',
          url: `/transactions/${this.transactionDetails.id}/send_receipt_email`
        })

        if (result.data && result.data.error === false) {
          Bus.$emit('openModal', {
            status: 'success',
            message: 'Email Sent'
          })
        } else {
          Bus.$emit('openModal', {
            status: 'error',
            message: 'Unexpected Error'
          })
        }
      } catch (err) {
        Bus.$emit('openModal', {
          status: 'error',
          message: err
        })
      }
    }
  }
}
</script>

<style lang="less">
  // Expand form fields to fill
  .v-window {
    width: 100%;
  }

  .main-card {
    border: solid 1px #9b9b9b !important;
    border-radius: 12px;
  }

  .xxl-icon {
    font-size: 128px;
  }

  .pay-button {
    background-image: linear-gradient(to bottom, #79d4f3, #1475ac);
    border: solid 2px #e1e1e2 !important;
    border-radius: 0px !important;
    box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.16);
  }

  .payment-input {
    border: solid 1px #979797;
  }

/*
  .payment-secondary-input-container {
    margin: 0 !important;
    padding: 0 !important;
    transform-origin: left;
    transform: scale(0.80);
  }

  .payment-secondary-input {
    margin: 0 !important;
    padding: 0 !important;
    // transform-origin: left;
    // transform: scale(0.80);
    height: 54px;
  }

  .payment-secondary-input label[for] {
    // transform-origin: left;
    // transform: scale(0.80);
  }
  */

/*
  .payment-input.v-text-field.v-text-field--enclosed .v-input__slot {
    margin: 0;
    padding: 0;
    height: 42px !important;
  }

  .payment-secondary-input-container {
    margin: 0 !important;
    padding: 0 !important;
    // transform-origin: left;
    // transform: scale(0.75);
  }

  .payment-secondary-input {
    margin: 0 !important;
    padding: 0 !important;
    // transform-origin: left;
    // transform: scale(0.75);
    height: 54px;
  }

  .payment-secondary-input label[for] {
    // transform-origin: left;
    // transform: scale(0.75);
  }

  .payment-secondary-input .v-input__control {
    margin: 0 !important;
    padding: 0 !important;
    // height: scale(0.75);
  }
*/

</style>



// WEBPACK FOOTER //
// src/components/plans/Payment.vue